import { render, staticRenderFns } from "./callTest.vue?vue&type=template&id=5fd6ca04&scoped=true&"
import script from "./callTest.vue?vue&type=script&lang=js&"
export * from "./callTest.vue?vue&type=script&lang=js&"
import style0 from "./callTest.vue?vue&type=style&index=0&id=5fd6ca04&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd6ca04",
  null
  
)

export default component.exports